/**
 * Главный файл инициализации приложения
 * Импортирует стили и инициализирует все модули
 */

// Импорт стилей
import '../styles/app.scss'

// Импорт модулей
import './cookie-banner'

import { initPopup } from './popup'
import { initAdditionalSections } from './sections'
import { initLevelTest } from './level-test'
import { initCoursesPage } from './courses'
import { initCourseDetailPage } from './course-detail'
// import { initCities } from './cities-block'
import { initMobileMenu } from './mobile-menu'

// Импорт утилит
import { initPhoneMasks } from './utils/phone-mask.js'
import { initScrollAnimation } from './utils/animations.js'

// Импорт модулей
import { initSmoothScrolling } from './modules/smooth-scroll.js'
import { initCoursesTabs, initBusinessTabs } from './modules/tabs.js'
import { initFAQ } from './modules/faq.js'
import { initTeachersSlider, initTestimonialsSlider, initEventsSlider, initSuccessStoriesSwiper } from './modules/sliders.js'

// Импорт функций для hero и других компонентов
import { initHeroAnimations } from './modules/hero.js'
import { initLanguageLevels } from './modules/language-levels.js'
import { initVideoPopup } from './modules/video-popup.js'
import { initBackToTopButton } from './modules/back-to-top.js'
import { initLandingPages } from './landings.js'
import { initContentPages } from './content-pages.js'

/**
 * Инициализация приложения при загрузке DOM
 */
document.addEventListener('DOMContentLoaded', () => {
  try {
    // Базовые функции
    initPopup()
    initSmoothScrolling()
    initPhoneMasks()
    initBackToTopButton()

    // Инициализация секций
    initAdditionalSections()
    initLanguageLevels()
    // initCities()

    // Мобильное меню
    initMobileMenu()

    // Табы
    initCoursesTabs()
    initBusinessTabs()

    // FAQ
    initFAQ()

    // Слайдеры
    initTeachersSlider()
    initTestimonialsSlider()
    initEventsSlider()
    initSuccessStoriesSwiper()

    // Hero анимации
    initHeroAnimations()

    // Видео попап
    initVideoPopup()

    // Специфичные для страниц инициализации
    initLevelTest()
    initCoursesPage()
    initCourseDetailPage()
    initLandingPages()
    initContentPages()

    // Анимации при скролле
    initScrollAnimation('section', 'fade-in', 100)
    initScrollAnimation(
      '.advantages__item, .course-card, .methodology__step, .stats__item, .why-us__item, .process__step, .faq__item, .business__panel, .summer-card, .partners__item, .teacher-card',
      'slide-up',
      100
    )

    console.log('[App] Инициализация завершена успешно')
  } catch (error) {
    console.error('[App] Ошибка при инициализации:', error)
  }
})
